import React, { PureComponent } from 'react';

import ArrayUtils from '../utils/ArrayUtils';
import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

import TagBox from 'devextreme-react/tag-box';

export default class StringListEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
    this.onFieldEditorInputEventListener = this.onFieldEditorInputEvent.bind(this);
    this.onFocusInListener = this.onFocusIn.bind(this);
    this.onFocusOutListener = this.onFocusOut.bind(this);

    this.tagBoxEditor = null;
    this.fieldEditor = null;
    this.fieldEditorContent = '';
  }

  render() {
    return (
      <TagBox
        acceptCustomValue={true}
        className={this.getEditorClassNames(this.props.useCompactEditor)}
        disabled={this.props.disabled}
        hideSelectedItems={true}
        name={this.props.name}
        onFocusIn={this.onFocusInListener}
        onFocusOut={this.onFocusOutListener}
        onValueChanged={this.onControlValueListener}
        openOnFieldClick={false}
        placeholder=""
        style={this.props.style}
        value={this.props.value || []}
        width={this.props.width}
     />
    );
  }

  getEditorClassNames(useCompactEditor) {
    var classNames = 'pwx-string-list-editor';
    if (useCompactEditor)
      classNames += ' pwx-string-list-compact-editor'
    else
      classNames += ' pwx-string-list-standard-editor'

    return classNames;
  }

  onControlValueChanged(event) {
    this.pendingStringValue = '';

    var values = event.value;
    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      values = this.props.postEditFilter(values);

    if (Array.isArray(values)) {
      values = values.map(value => value.trim());
      values = values.filter(value => value.length > 0);
      values = StringUtils.sortStringArray(values, true);

      if (!ArrayUtils.areArraysEquivalent(event.value, values)) {
        event.component.option('values', values);
      }
    }

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, values);
  }

  onFocusOut(event) {
    this.processPendingStringValue();

    if (CoreUtils.isUndefinedOrNull(this.fieldEditor))
      return;

    this.fieldEditor.removeEventListener(
      'input',
      this.onFieldEditorInputEventListener
    );

    this.fieldEditor = null;
    this.tagBoxEditor = null;
  }

  onFocusIn(event) {
    this.fieldEditorContent = '';

    this.tagBoxEditor = event.component;
    if (CoreUtils.isUndefinedOrNull(this.tagBoxEditor))
      return;

    this.fieldEditor = this.tagBoxEditor.field();
    if (CoreUtils.isUndefinedOrNull(this.fieldEditor))
      return;

    this.fieldEditor.addEventListener(
      'input',
      this.onFieldEditorInputEventListener
    );
  }

  onFieldEditorInputEvent(event) {
    this.pendingStringValue = this.fieldEditor.value;
  }

  processPendingStringValue() {
    if (CoreUtils.isUndefinedOrNull(this.tagBoxEditor)
      || CoreUtils.isUndefinedOrNull(this.fieldEditor)
      || StringUtils.isNullOrWhitespace(this.pendingStringValue))
      return;

    this.tagBoxEditor._createCustomItem(this.tagBoxEditor.option('text'));
    this.tagBoxEditor._completeSelection(this.pendingStringValue);

    this.fieldEditor.value = '';
    this.pendingStringValue = '';
  }
}